import { Button } from "@material-ui/core";
import React from "react";
import {
  Box,
  ButtonBase,
  FormControl,
  InputLabel,
  Link,
  MenuItem,
  Modal,
  TextField,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2"; // Grid version 2
import {
  validatePincode,
  validateRegno,
} from "../../../Supporting files/HelpingFunction";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { LocalizationProvider, MobileDatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import RKTextField from "../../../Supporting files/RKTextField/RKTextField";
import SelectDropdown from "../../../Supporting files/SelectDropdown/SelectDropdown";
import DatePicker from "../../../Supporting files/DatePicker/DatePicker";
import SlidingPanel from "react-sliding-side-panel";
import SearchDropdown from "../../../Supporting files/SearchDropdown/SearchDropdown";

interface Props {
  attrName: string;
  open_status: boolean;
  value_update: Function;
}

const CarForm: React.FC<Props> = ({ open_status, value_update, attrName }) => {
  //const [carFormPageStatus, setCarFormPageStatus] = React.useState(1);
  const [pageStatus, setPageStatus] = React.useState<number>(1);
  const [rto, setRto] = React.useState("");
  const [regNo, setRegNo] = React.useState("");
  const [policyExpiryStatus, setPolicyExpiryStatus] = React.useState("");
  const [makeModel, setMakeModel] = React.useState("");
  const [fuelType, setFuelType] = React.useState("");
  const [variant, setVariant] = React.useState("");
  const [prevInsurer, setPrevInsurer] = React.useState("");
  const [regDate, setRegDate] = React.useState<Date | null>(null);
  const [claimStatus, setClaimStatus] = React.useState("");
  const [prevNCB, setPrevNCB] = React.useState(0);
  const [warnRegNo, setWarnRegNo] = React.useState(false);
  const [warnPolicyExpiryStatus, setWarnPolicyExpiryStatus] =
    React.useState(false);
  const [warnMakeModel, setWarnMakeModel] = React.useState(false);
  const [warnFuelType, setWarnFuelType] = React.useState(false);
  const [warnVariant, setWarnVariant] = React.useState(false);
  const [warnPrevInsurer, setWarnPrevInsurer] = React.useState(false);
  const [warnRegDate, setWarnRegDate] = React.useState(false);
  const [warnClaimStatus, setWarnClaimStatus] = React.useState(false);
  const [warnRTO, setWarnRTO] = React.useState(false);

  const updateMasterState = (
    attrName: any,
    value: string | boolean | number
  ) => {
    attrName(value);
  };

  const validateCarForm = () => {
    if (pageStatus == 1) {
      // let warn_reg_no = !validateRegno(regNo);
      let warn_reg_no = false;
      let warn_policy_expiry_status =
        policyExpiryStatus.toString().length == 0 ? true : false;

      setWarnRegNo(warn_reg_no);
      setWarnPolicyExpiryStatus(warn_policy_expiry_status);

      if (warn_reg_no == false && warn_policy_expiry_status == false) {
        setPageStatus(2);
      }
    } else if (pageStatus == 2) {
      let warn_make_model = makeModel.toString().length == 0 ? true : false;
      let warn_fuel_type = fuelType.toString().length == 0 ? true : false;
      let warn_variant = variant.toString().length == 0 ? true : false;
      let warn_prev_insurer = prevInsurer.toString().length == 0 ? true : false;
      let warn_reg_date =
        regDate == undefined
          ? true
          : regDate.toString().length == 0
          ? true
          : false;
      let warn_claim_status = claimStatus.toString().length == 0 ? true : false;

      setWarnMakeModel(warn_make_model);
      setWarnFuelType(warn_fuel_type);
      setWarnVariant(warn_variant);
      setWarnPrevInsurer(warn_prev_insurer);
      setWarnRegDate(warn_reg_date);
      setWarnClaimStatus(warn_claim_status);

      if (
        warn_make_model == false &&
        warn_fuel_type == false &&
        warn_variant == false &&
        warn_prev_insurer == false &&
        warn_reg_date == false &&
        warn_claim_status == false
      ) {
      }
    } else if (pageStatus == 3) {
      let warn_rto = rto.toString().length == 0 ? true : false;

      setWarnRTO(warn_rto);

      if (warn_rto == false) {
        setPageStatus(2);
      }
    }
  };

  const policyExpiry_data = [
    { key: "Quaterly", value: "Quaterly" },
    { key: "Half yearly", value: "Half yearly" },
    { key: "Annually", value: "Annually" },
  ];
  const claimStatus_data = [
    { key: "Yes", value: "Yes" },
    { key: "No", value: "No" },
  ];
  const rto_data = [
    { key: "RJ 01 Ajmer", value: "RJ 01 Ajmer" },
    { key: "CH 01 Chandigarh", value: "CH 01 Chandigarh" },
    { key: "PB 01 Amritsar", value: "PB 01 Amritsar" },
    { key: "PB 01 Amritsar", value: "PB 01 Amritsar" },
  ];
  const MakeModel_data = [
    { key: "Honda", value: "Honda" },
    { key: "Hyuandi", value: "Hyuandi" },
    { key: "Tata", value: "Tata" },
    { key: "Suzuki", value: "Suzuki" },
  ];
  const FuelType_data = [
    { key: "Diesel", value: "Diesel" },
    { key: "Petrol", value: "Petrol" },
    { key: "Electric", value: "Electric" },
  ];
  const Variant_data = [
    { key: "Nexon", value: "Nexon" },
    { key: "Brezza", value: "Brezza" },
    { key: "Grand i20", value: "Grand i20" },
    { key: "Honda City", value: "Honda City" },
  ];
  const prevInsurer_data = [
    { key: "Reliance", value: "Reliance" },
    { key: "Go Digit", value: "Go Digit" },
    { key: "Chola Mandlam", value: "Chola Mandlam" },
    { key: "Star", value: "Star" },
  ];

  const changePageStatus = (status: boolean) => {
    if (status === true) {
      if (pageStatus < 2) {
        setPageStatus(pageStatus + 1);
      }
    } else {
      if (pageStatus > 1) {
        setPageStatus(pageStatus - 1);
      }
    }
  };

  return (
    <>
      <SlidingPanel
        type={"right"}
        isOpen={open_status}
        size={75}
        panelClassName="slidingPanel"
        backdropClicked={() => value_update(attrName, false)}
      >
        <Box className={open_status == true ? "modalInner show" : "modalInner"}>
          {pageStatus == 3 ? null : (
            <Grid container spacing={3} alignItems="center">
              <Grid xs={12}>
                <h4 className="mb-0 mt-2">Car Insurance</h4>
              </Grid>
              <Grid xs={12}>
                <hr />
              </Grid>
            </Grid>
          )}
          {pageStatus == 3 ? null : (
            <div className="scrollable_area">
              <Grid container spacing={3}>
                <Grid xs={12}>
                  <Accordion
                    expanded={pageStatus === 1}
                    onChange={() => setPageStatus(1)}
                  >
                    <AccordionSummary aria-controls="1-content" id="1-header">
                      <Typography>Car Details</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography>
                        <Grid container spacing={2} justifyContent="center">
                          <Grid xs={6}>
                            <RKTextField
                              class_name="inputField"
                              title="Reg No."
                              value={regNo}
                              value_update={updateMasterState}
                              attrName={setRegNo}
                              warn_status={warnRegNo}
                            />
                          </Grid>
                          <Grid xs={6}>
                            <SelectDropdown
                              class_name="inputField"
                              title="Policy Expiry"
                              value={policyExpiryStatus}
                              attrName={setPolicyExpiryStatus}
                              value_update={updateMasterState}
                              dropdown_data={policyExpiry_data}
                              warn_status={false}
                            />
                          </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                          <Grid
                            xs={12}
                            className="ctaBtn"
                            style={{ textAlign: "center" }}
                          >
                            <Link
                              className="md-link"
                              underline="none"
                              onClick={() => {
                                setPageStatus(2);
                              }}
                            >
                              Bought a new Car ?
                            </Link>
                          </Grid>
                        </Grid>
                      </Typography>
                    </AccordionDetails>
                  </Accordion>

                  <Accordion
                    expanded={pageStatus === 2}
                    onChange={() => setPageStatus(2)}
                  >
                    <AccordionSummary aria-controls="2-content" id="2-header">
                      <Typography>Car Details</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography>
                        <Grid container spacing={2} justifyContent="center">
                          <Grid xs={6} className="inputField">
                            <SelectDropdown
                              class_name="inputField"
                              title="Make & Model"
                              value={makeModel}
                              attrName={setMakeModel}
                              value_update={updateMasterState}
                              dropdown_data={MakeModel_data}
                              warn_status={false}
                            />
                          </Grid>
                          <Grid xs={6} className="inputField">
                            <SelectDropdown
                              class_name="inputField"
                              title="Fuel Type"
                              value={fuelType}
                              attrName={setFuelType}
                              value_update={updateMasterState}
                              dropdown_data={FuelType_data}
                              warn_status={false}
                            />
                          </Grid>
                          <Grid xs={12} className="inputField">
                            <SelectDropdown
                              class_name="inputField"
                              title="Variant"
                              value={variant}
                              attrName={setVariant}
                              value_update={updateMasterState}
                              dropdown_data={Variant_data}
                              warn_status={false}
                            />
                          </Grid>
                          <Grid xs={12} className="inputField">
                            <SelectDropdown
                              class_name="inputField"
                              title="Previous Insurer"
                              value={prevInsurer}
                              attrName={setPrevInsurer}
                              value_update={updateMasterState}
                              dropdown_data={prevInsurer_data}
                              warn_status={false}
                            />
                          </Grid>
                          <Grid xs={6} className="inputField">
                            <DatePicker
                              class_name="inputField"
                              title="Reg. Date"
                              value={regDate}
                              attrName={setRegDate}
                              value_update={updateMasterState}
                              error_message="Please enter Reg. Date"
                              warn_status={false}
                            />
                          </Grid>
                          <Grid xs={6} className="inputField mb-3">
                            <SelectDropdown
                              class_name="inputField"
                              title="Claim"
                              value={claimStatus}
                              attrName={setClaimStatus}
                              value_update={updateMasterState}
                              dropdown_data={claimStatus_data}
                              warn_status={false}
                            />
                          </Grid>
                        </Grid>
                        {claimStatus == "No" ? (
                          <Grid container spacing={2}>
                            <Grid xs={12} textAlign="center">
                              <h6 className="popup-subheading">
                                No Claim Bonus
                              </h6>
                              <div className="main-border-ncb">
                                <Button
                                  className={prevNCB == 0 ? "ncbSelect" : "ncb"}
                                  onClick={() => {
                                    setPrevNCB(0);
                                  }}
                                >
                                  0%
                                </Button>
                                <Button
                                  className={
                                    prevNCB == 20 ? "ncbSelect" : "ncb"
                                  }
                                  onClick={() => {
                                    setPrevNCB(20);
                                  }}
                                >
                                  20%
                                </Button>
                                <Button
                                  className={
                                    prevNCB == 25 ? "ncbSelect" : "ncb"
                                  }
                                  onClick={() => {
                                    setPrevNCB(25);
                                  }}
                                >
                                  25%
                                </Button>
                                <Button
                                  className={
                                    prevNCB == 35 ? "ncbSelect" : "ncb"
                                  }
                                  onClick={() => {
                                    setPrevNCB(35);
                                  }}
                                >
                                  35%
                                </Button>
                                <Button
                                  className={
                                    prevNCB == 50 ? "ncbSelect" : "ncb"
                                  }
                                  onClick={() => {
                                    setPrevNCB(50);
                                  }}
                                >
                                  50%
                                </Button>
                              </div>
                            </Grid>
                          </Grid>
                        ) : null}
                      </Typography>
                    </AccordionDetails>
                  </Accordion>

                  <Accordion
                    expanded={pageStatus === 3}
                    onChange={() => setPageStatus(3)}
                  >
                    <AccordionSummary aria-controls="3-content" id="3-header">
                      <Typography>New Vehicle Details</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid container spacing={2} justifyContent="center">
                        <Grid xs={12} className="inputField">
                          <SelectDropdown
                            class_name="inputField"
                            title="RTO / City Name"
                            value={rto}
                            attrName={setRto}
                            value_update={updateMasterState}
                            dropdown_data={rto_data}
                            warn_status={false}
                          />
                        </Grid>
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                </Grid>
              </Grid>
            </div>
          )}
          {pageStatus == 3 ? (
            <Grid container spacing={2}>
              <Grid xs={12} className="tick_animation">
                <svg
                  className="checkmark"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 52 52"
                >
                  <circle
                    className="checkmark__circle"
                    cx="26"
                    cy="26"
                    r="25"
                    fill="none"
                  />
                  <path
                    className="checkmark__check"
                    fill="none"
                    d="M14.1 27.2l7.1 7.2 16.7-16.8"
                  />
                </svg>
                <p className="quote_success">
                  New Car Insurance Policy has been added successfully!
                </p>
              </Grid>
            </Grid>
          ) : null}
          <Grid container spacing={2}>
            {pageStatus == 3 ? null : (
              <Grid
                xs={12}
                style={{ textAlign: "center", position: "relative" }}
                className="ctaBtn"
              >
                <Button
                  variant="contained"
                  className="submitBtn fixedbtn"
                  onClick={() => {
                    changePageStatus(true);
                  }}
                >
                  {pageStatus == 2 ? "Submit" : "Continue"}
                </Button>
              </Grid>
            )}
          </Grid>
        </Box>
      </SlidingPanel>
    </>
  );
};

export default CarForm;
